'use client';
import { useState, useEffect, useContext } from 'react';
import { ScreenClassContext } from '../../contexts/screen-class-provider/index.js';
import { isNotProduction } from '../../../core/utilities/env.utils.js';

const useSlidesToShow = (t = 1)=>{
    let r = useContext(ScreenClassContext);
    if ('number' == typeof t) return t;
    let s = 1;
    if (void 0 === r) {
        if (isNotProduction()) throw Error("A responsive value for `slidesToShow` may only be used inside of a ScreenClassProvider. Make sure that you've rendered a ScreenClassProvider above this component your tree.");
        return s;
    }
    for (let e of [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ]){
        var n;
        if (s = null !== (n = t[e]) && void 0 !== n ? n : s, r === e) break;
    }
    return s;
};
const useCustomArrowHeight = (e, o)=>{
    let [l, s] = useState(null);
    return useEffect(()=>{
        if (!('ResizeObserver' in window)) return;
        let t = new ResizeObserver(()=>{
            if (!e.current) return;
            let t = null;
            for (let r of o)if (t = e.current.querySelector(r)) break;
            t && s(t.clientHeight / 2);
        });
        return e.current && t.observe(e.current), ()=>t.disconnect();
    }, [
        e,
        o
    ]), l;
};
let getSlideCount = (e, t)=>{
    if ('object' == typeof e) {
        let r = e[t];
        return r ? Math.floor(r) : void 0;
    }
    if ('number' == typeof e) return Math.floor(e);
};
function useCarouselPagination({ derivedSlidesToShow: e, firstVisibleSlideIndex: t, totalSlides: r }) {
    let o, l = [], s = Math.floor(useSlidesToShow(e)), n = s - 1 || 1;
    if (1 === s) l = Array.from({
        length: r
    }, (e, t)=>t);
    else {
        let e = 0;
        for(; e + s <= r;)l.push(e), e += n;
        let t = r - s;
        !l.includes(t) && t >= 0 && l.push(t);
    }
    let i = 0 === t, a = t + s >= r;
    i ? o = l[0] : a ? o = l[l.length - 1] : (o = Math.max(...l.filter((e)=>e <= t))) !== l[0] || i || (o = l[1]);
    let u = t + (s - 1);
    r && u > r - 1 && (u = r - 1);
    let d = {
        '--swan-internal-adaptive-carousel-slides-to-show-derived': s,
        '--swan-internal-adaptive-carousel-slides-to-show-xs': getSlideCount(e, 'xs'),
        '--swan-internal-adaptive-carousel-slides-to-show-sm': getSlideCount(e, 'sm'),
        '--swan-internal-adaptive-carousel-slides-to-show-md': getSlideCount(e, 'md'),
        '--swan-internal-adaptive-carousel-slides-to-show-lg': getSlideCount(e, 'lg'),
        '--swan-internal-adaptive-carousel-slides-to-show-xl': getSlideCount(e, 'xl')
    };
    return {
        calculatedSlidesToShow: s,
        closestPage: o,
        lastVisibleSlideIndex: u,
        pages: l,
        scrolledToEnd: a,
        slidesToScroll: n,
        slidesToShowStyle: d
    };
}

export { useCarouselPagination, useCustomArrowHeight, useSlidesToShow };
